module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "To anyone",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "outbound",
    attrs: {
      "model": _vm.outbound,
      "label-position": "top",
      "label-width": "220px"
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("Outbound items")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-left": "20px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.showAddInventory
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changeCustomizationPage(1)
      }
    }
  }, [_vm._v("Add customization Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.outbound.items,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h3', [_vm._v(_vm._s(scope.row.productNme))]), _vm._v(" "), (scope.row.mainProductName) ? _c('h3', [_vm._v(_vm._s("Main Product : " + scope.row.mainProductName))]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _vm._l((scope.row.items), function(sub, index) {
          return _c('p', {
            key: index,
            staticClass: "note",
            staticStyle: {
              "margin-bottom": "2px"
            }
          }, [_vm._v("\n                                        " + _vm._s(sub.qty) + " x " + _vm._s(sub.productName) + "(" + _vm._s(sub.upc) + ") "), (sub.service && sub.service !== 'None') ? _c('span', {
            staticStyle: {
              "color": "#ff2218"
            }
          }, [_vm._v(_vm._s(sub.service))]) : _vm._e()])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "To ship",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          attrs: {
            "min": 1,
            "max": scope.row.qty ? parseInt(scope.row.qty) : 99999
          },
          model: {
            value: (scope.row.toShip),
            callback: function($$v) {
              _vm.$set(scope.row, "toShip", $$v)
            },
            expression: "scope.row.toShip"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "width": "100px",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeInventory(scope.row)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Package Label"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "auto-upload": false,
      "name": "file",
      "drag": "",
      "action": _vm.uploadUrl,
      "http-request": _vm.upload,
      "file-list": _vm.fileList,
      "headers": _vm.headers
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('em', [_vm._v("click to upload")]), _vm._v(" or drag and drop file")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tracking number",
      "prop": "trackingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.trackingNumber),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "trackingNumber", $$v)
      },
      expression: "outbound.trackingNumber"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Optional.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Carrier",
      "prop": "carrier"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.carrier),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "carrier", $$v)
      },
      expression: "outbound.carrier"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Optional.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Carrier name",
      "prop": "carrierName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.carrierName),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "carrierName", $$v)
      },
      expression: "outbound.carrierName"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Required if carrier is  'Other'.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "user"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.user),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "user", $$v)
      },
      expression: "outbound.user"
    }
  }, _vm._l((_vm.members), function(member, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": member.username,
        "value": member.userNo
      }
    })
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("By default, the user of the first shipment item will be notified.")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Priority",
      "prop": "priority"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.outbound.priority),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "priority", $$v)
      },
      expression: "outbound.priority"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 0,
      "label": "Normal"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 1,
      "label": "Medium"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "Urgent"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Numb of box Per Shipment",
      "prop": "splitPackagesNum"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 99999
    },
    model: {
      value: (_vm.outbound.splitPackagesNum),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "splitPackagesNum", $$v)
      },
      expression: "outbound.splitPackagesNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Instruction",
      "prop": "instruction"
    }
  }, [_c('el-row', [_c('el-select', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "Append preset",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.changeInstruction
    },
    model: {
      value: (_vm.selectedInstruction),
      callback: function($$v) {
        _vm.selectedInstruction = $$v
      },
      expression: "selectedInstruction"
    }
  }, _vm._l((_vm.instructionTemps), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item.instructionName
      }
    })
  }), 1), _vm._v(" "), _c('el-link', {
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": _vm.getInstructionListByPage
    }
  }, [_vm._v("Instruction Template")])], 1), _vm._v(" "), _c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.outbound.instruction),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "instruction", $$v)
      },
      expression: "outbound.instruction"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Instruction (optional) will only appear in the email sent to the user.")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.outbound.note),
      callback: function($$v) {
        _vm.$set(_vm.outbound, "note", $$v)
      },
      expression: "outbound.note"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Store essential information in note for future reference.")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleOutbound
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Working",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.workingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingFilter", $$v)
      },
      expression: "filters.workingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getWorkingOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.workingMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workingMainFilter", $$v)
      },
      expression: "filters.workingMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getWorkingOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'working.xls', '1')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.workingLoading),
      expression: "workingLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.workingList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "min-width": "3%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name",
      "min-width": "30%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction",
      "min-width": "22%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note",
      "min-width": "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users",
      "min-width": "8%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "min-width": "12%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.closeOutbound(scope.row.outboundId)
            }
          }
        }, [_vm._v("Cancel")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.workingTotal
    },
    on: {
      "current-change": _vm.changeWorkingList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Archived",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.archivedFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedFilter", $$v)
      },
      expression: "filters.archivedFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getArchivedOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.archivedMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "archivedMainFilter", $$v)
      },
      expression: "filters.archivedMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getArchivedOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'archived.xls', '2')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.archivedLoading),
      expression: "archivedLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.archivedList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row.outboundId)
            }
          }
        }, [_vm._v("Package Label")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.archivedTotal
    },
    on: {
      "current-change": _vm.changeArchivedList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Cancelled",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCloseOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.closeFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "closeFilter", $$v)
      },
      expression: "filters.closeFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCloseOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Main Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCloseOutboundList($event)
      }
    },
    model: {
      value: (_vm.filters.closeMainFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "closeMainFilter", $$v)
      },
      expression: "filters.closeMainFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCloseOutboundList
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportOutboundByType', 'Cancelled.xls', '3')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.closeLoading),
      expression: "closeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.closeList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outboundId",
      "label": "#",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.productName)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instruction",
      "label": "Instruction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instruction)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "users",
      "label": "Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Split Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundDate",
      "label": "Outbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.closeTotal
    },
    on: {
      "current-change": _vm.changeCloseList
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transfer To",
      "name": "five"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "inline": true
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Product Name",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTransferProductList($event)
      }
    },
    model: {
      value: (_vm.filters.productFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productFilter", $$v)
      },
      expression: "filters.productFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransferProductList
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productLoading),
      expression: "productLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.productList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product",
      "width": "400px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.condition) + " - "), _c('b', [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" (" + _vm._s(scope.row.createDate) + ")\n                            "), _c('p', [_vm._v(_vm._s(scope.row.upc))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v(_vm._s(scope.row.note))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stock",
      "label": "FBM"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showWarehouseFBM(scope.row.productNo)
            }
          }
        }, [_vm._v("Transfer")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.productTotal
    },
    on: {
      "current-change": _vm.handleProductPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    key: 'transferLogsTab',
    attrs: {
      "label": "Transfer Logs",
      "name": "six"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.transferLogsLoading),
      expression: "transferLogsLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transferLogsList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferNo",
      "label": "Transfer#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Transferer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToUserName",
      "label": "Acceptor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseAddress",
      "label": "Transfer Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transferToAddress",
      "label": "Acceptor Warehouse Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Transfer Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moved",
      "label": "Checked"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            color: scope.row.moved ? 'green' : 'red'
          })
        }, [_vm._v("\n                                " + _vm._s(scope.row.moved ? "Yes" : "No") + "\n                            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateDate",
      "label": "Checked Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.transferLogsPageSize,
      "total": _vm.transferLogsWorkingTotal
    },
    on: {
      "current-change": _vm.getTrasferUserLogs
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product Summary",
      "width": "80%",
      "visible": _vm.inventroySummary,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.inventroySummary = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInventorySummary($event)
      }
    },
    model: {
      value: (_vm.filters.inventoryProductSummary),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProductSummary", $$v)
      },
      expression: "filters.inventoryProductSummary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchInventorySummary
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": _vm.getInventorySummaryByUser
    },
    model: {
      value: (_vm.filters.inventorySummaryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventorySummaryNurse", $$v)
      },
      expression: "filters.inventorySummaryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.filters.inventorySummaryNurse) ? _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventorySummaryLoading),
      expression: "inventorySummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventoriesSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.getInventory(scope.row.productNo)
            }
          }
        }, [_vm._v("Detail")])]
      }
    }], null, false, 2992596343)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventorySummaryTotal
    },
    on: {
      "current-change": _vm.handleInventorySummaryPageChange
    }
  })], 1)], 1) : _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventorySummaryLoading),
      expression: "inventorySummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventoriesSummaryByUser,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.selectInventory(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.selected ? 'selected' : 'select'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventorySummaryByUserTotal
    },
    on: {
      "current-change": _vm.handleInventorySummaryByUserPageChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.inventroySummary = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Product",
      "width": "80%",
      "visible": _vm.addInventory,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addInventory = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInventory(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryProduct),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryProduct", $$v)
      },
      expression: "filters.inventoryProduct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getInventory(null)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter by user",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getInventory(null)
      }
    },
    model: {
      value: (_vm.filters.inventoryNurse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "inventoryNurse", $$v)
      },
      expression: "filters.inventoryNurse"
    }
  }, _vm._l((_vm.members), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.inventoryLoading),
      expression: "inventoryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.inventories,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "productNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDoctor == 0) ? _c('p', [_c('i', {
          staticClass: "fa fa-university"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e(), _vm._v(" "), (scope.row.isDoctor == 1) ? _c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v("   " + _vm._s(scope.row.warehouse))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.selectInventory(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.selected ? 'selected' : 'select'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.inventoryTotal
    },
    on: {
      "current-change": _vm.handleInventoryPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addInventory = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Customization Product",
      "width": "80%",
      "visible": _vm.customizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customizationVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Template Name or Mian Product",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomizationProduct($event)
      }
    },
    model: {
      value: (_vm.filters.customizationName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "customizationName", $$v)
      },
      expression: "filters.customizationName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getCustomizationProduct
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openNewCustomizationWindow
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.customizationLoading),
      expression: "customizationLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customizationProduct,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "templateName",
      "label": "Template Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mainProductName",
      "label": "Main Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product",
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h3', [_vm._v(_vm._s(scope.row.product))]), _vm._v(" "), _vm._l((scope.row.items), function(sub, index) {
          return _c('p', {
            key: index,
            staticClass: "note"
          }, [_vm._v("\n                            " + _vm._s(sub.productName) + " * " + _vm._s(sub.qty) + " "), (sub.service && sub.service !== 'None') ? _c('span', {
            staticStyle: {
              "color": "#ff2218"
            }
          }, [_vm._v("(" + _vm._s(sub.service) + ")")]) : _vm._e()])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.selectCustomization(scope.row)
            }
          }
        }, [_vm._v("Select")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.eitCustomization(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCustomization(scope.row.id)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.customizationVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Customization Product",
      "width": "80%",
      "visible": _vm.addCustomizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addCustomizationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "customization",
    attrs: {
      "model": _vm.customization,
      "label-width": "220px",
      "rules": _vm.customizationRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouse"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.getProductsByWarehouseId
    },
    model: {
      value: (_vm.customization.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.customization, "warehouse", $$v)
      },
      expression: "customization.warehouse"
    }
  }, _vm._l((_vm.warehouses), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.state + ' ' + w.city + ' ' + w.address,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.customization.warehouse) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Main Product",
      "prop": "mainProduct"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": true
    },
    model: {
      value: (_vm.customization.mainProduct),
      callback: function($$v) {
        _vm.$set(_vm.customization, "mainProduct", $$v)
      },
      expression: "customization.mainProduct"
    }
  }, _vm._l((_vm.inventories), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productNme + '(Stock:' + product.stock + ')'
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product Qty",
      "prop": "mainProductQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.customization.mainProductQty),
      callback: function($$v) {
        _vm.$set(_vm.customization, "mainProductQty", $$v)
      },
      expression: "customization.mainProductQty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.customization.name),
      callback: function($$v) {
        _vm.$set(_vm.customization, "name", $$v)
      },
      expression: "customization.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Products"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAccessories
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.customization.sub,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((_vm.inventories), function(product, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": product.productNo,
              "label": product.productNme + '(Stock:' + product.stock + ')'
            }
          })
        }), 1)]
      }
    }], null, false, 3483873928)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Qty",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }], null, false, 4082218523)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Service",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.service),
            callback: function($$v) {
              _vm.$set(scope.row, "service", $$v)
            },
            expression: "scope.row.service"
          }
        }, [_c('el-option', {
          attrs: {
            "value": "None"
          }
        }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.serviceList), function(service, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": service,
              "label": service
            }
          })
        })], 2)]
      }
    }], null, false, 2962174138)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSub(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }], null, false, 1512946399)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addCustomizationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addCustomizationTemplate($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Customization Product",
      "width": "80%",
      "visible": _vm.editCustomizationVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editCustomizationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editCustomization",
    attrs: {
      "model": _vm.editCustomization,
      "label-width": "220px",
      "rules": _vm.customizationRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Warehouse",
      "prop": "warehouse"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.getProductsByWarehouseId
    },
    model: {
      value: (_vm.editCustomization.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "warehouse", $$v)
      },
      expression: "editCustomization.warehouse"
    }
  }, _vm._l((_vm.warehouses), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.state + ' ' + w.city + ' ' + w.address,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.editCustomization.warehouse) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editCustomization.name),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "name", $$v)
      },
      expression: "editCustomization.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product",
      "prop": "mainProduct"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": true
    },
    model: {
      value: (_vm.editCustomization.mainProduct),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "mainProduct", $$v)
      },
      expression: "editCustomization.mainProduct"
    }
  }, _vm._l((_vm.inventories), function(product, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": product.productNo,
        "label": product.productNme + '(Stock:' + product.stock + ')'
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Product Qty",
      "prop": "mainProductQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.editCustomization.mainProductQty),
      callback: function($$v) {
        _vm.$set(_vm.editCustomization, "mainProductQty", $$v)
      },
      expression: "editCustomization.mainProductQty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Products"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addEditAccessories
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.editCustomization.sub,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.productNo),
            callback: function($$v) {
              _vm.$set(scope.row, "productNo", $$v)
            },
            expression: "scope.row.productNo"
          }
        }, _vm._l((_vm.inventories), function(product, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": product.productNo,
              "label": product.productNme + '(Stock:' + product.stock + ')'
            }
          })
        }), 1)]
      }
    }], null, false, 3483873928)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Qty",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }], null, false, 4082218523)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Service",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": true
          },
          model: {
            value: (scope.row.service),
            callback: function($$v) {
              _vm.$set(scope.row, "service", $$v)
            },
            expression: "scope.row.service"
          }
        }, [_c('el-option', {
          attrs: {
            "value": "None"
          }
        }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.serviceList), function(service, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "value": service,
              "label": service
            }
          })
        })], 2)]
      }
    }], null, false, 2962174138)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteEditSub(scope.row)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }], null, false, 1628885603)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editCustomizationVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editCustomizationTemplate($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Instruction Template",
      "width": "80%",
      "visible": _vm.instructionTemplateVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.instructionTemplateVisiable = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addInstructionVisible = true
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.instructionLoading),
      expression: "instructionLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.instructionListPage,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "prop": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "instructionName",
      "label": "Instruction Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Text"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instructionText)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.instructionNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editInstruction(scope.row)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteInstruction(scope.row.id)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.instructionTotal
    },
    on: {
      "current-change": _vm.handleInventoryPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.instructionTemplateVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Instruction",
      "width": "80%",
      "visible": _vm.addInstructionVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addInstructionVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addInstruction",
    attrs: {
      "model": _vm.addInstruction,
      "label-width": "220px",
      "rules": _vm.addInstructionRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addInstruction.name),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "name", $$v)
      },
      expression: "addInstruction.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text",
      "prop": "text"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addInstruction.text),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "text", $$v)
      },
      expression: "addInstruction.text"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.addInstruction.note),
      callback: function($$v) {
        _vm.$set(_vm.addInstruction, "note", $$v)
      },
      expression: "addInstruction.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addInstructionVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddInstruction($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Instruction",
      "width": "80%",
      "visible": _vm.editInstructionVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editInstructionVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editInstructionObj",
    attrs: {
      "model": _vm.editInstructionObj,
      "label-width": "220px",
      "rules": _vm.addInstructionRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editInstructionObj.name),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "name", $$v)
      },
      expression: "editInstructionObj.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text",
      "prop": "text"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editInstructionObj.text),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "text", $$v)
      },
      expression: "editInstructionObj.text"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.editInstructionObj.note),
      callback: function($$v) {
        _vm.$set(_vm.editInstructionObj, "note", $$v)
      },
      expression: "editInstructionObj.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editInstructionVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleEditInstruction($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Product FBM List",
      "width": "80%",
      "visible": _vm.fbmModelVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.fbmModelVisiable = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fbmLoading),
      expression: "fbmLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.fbmDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNme",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseUserName",
      "label": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showTransfer(scope.row.productNo, scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Transfer To")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.fbmTotal
    },
    on: {
      "current-change": _vm.handleInventoryDetailPageChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fbmModelVisiable = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Transfer To",
      "width": "40%",
      "visible": _vm.transferModelVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.transferModelVisiable = $event
      }
    }
  }, [_c('el-form', {
    ref: "transferForm",
    attrs: {
      "model": _vm.transferForm,
      "label-width": "220px",
      "rules": _vm.transferRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Product Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.productName),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "productName", $$v)
      },
      expression: "transferForm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "warehouse", $$v)
      },
      expression: "transferForm.warehouse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UPC"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.upc),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "upc", $$v)
      },
      expression: "transferForm.upc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Qty"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.transferForm.qty),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "qty", $$v)
      },
      expression: "transferForm.qty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer To",
      "prop": "to"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "User Name"
    },
    model: {
      value: (_vm.transferForm.to),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "to", $$v)
      },
      expression: "transferForm.to"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Qty",
      "prop": "transferQty"
    }
  }, [_c('el-input-number', {
    attrs: {
      "max": parseInt(_vm.transferForm.qty)
    },
    model: {
      value: (_vm.transferForm.transferQty),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "transferQty", $$v)
      },
      expression: "transferForm.transferQty"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.transferModelVisiable = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.transferTo($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d12b9dd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/outbound.vue
// module id = 805
// module chunks = 1